export default "__VITE_ASSET__DzpTkiwU__"